/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import { createLogic } from 'redux-logic';

import { RECEIVED_UPDATE_DIVIDENDS_CAPITAL_GAINS } from 'state/preferences/PreferencesActions';
import { addToast } from 'state/toast/ToastActions';
import {
  analyticsActionError,
  analyticsActionSuccess
} from 'state/analytics/AnalyticsActions';

const UpdateDividendCapitalGainLogic = createLogic({
  type: RECEIVED_UPDATE_DIVIDENDS_CAPITAL_GAINS,
  process({ action }, dispatch, done) {
    const { dividendsAndCapitalGains } = action;
    const { distributionOptions, withholdingOptions } =
      dividendsAndCapitalGains;

    const distributionError = distributionOptions.some((distribution) => {
      const { disposition } = distribution;
      return disposition && disposition.result === false;
    });

    const withholdingError = withholdingOptions.some((withholding) => {
      const { disposition } = withholding;
      return disposition && disposition.result === false;
    });

    if (!distributionError && !withholdingError) {
      // dispatch user message
      dispatch(addToast(true, 'Changes Saved'));

      // dispatch analytics message
      dispatch(
        analyticsActionSuccess('ProfPref', 'UpdateDividendsCapitalGains')
      );
    } else {
      // dispatch user message
      const title = '';
      const message =
        'There was an error updating the following information: Dividends & Capital Gains';
      dispatch(addToast(false, title, message));

      // dispatch analytics message
      dispatch(analyticsActionError('UpdateDividendsCapitalGains'));
    }

    done();
  }
});

export default UpdateDividendCapitalGainLogic;
